export const authInitialState = null;
